// @flow
import React from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Redirect, Route, Switch } from 'react-router';
import { connect } from 'react-redux';
import styles from './styles.module.scss';
import routes from '../../constants/routes';
import SignUp from './SignUp';
import LogIn from './LogIn';
import RecoveryPassword from './RecoverPassword';
import ResetPassword from './ResetPassword';
import Congratulations from './Congratulations';
import EmailNotification from './EmailNotification';
import PasswordChangeSuccess from './PasswordChangeSuccess';
import ConfirmEmail from './ConfirmEmail';

type Props = {
  isAuthenticated: boolean,
};

const Auth = ({ isAuthenticated }: Props) => {
  if (isAuthenticated) {
    return <Redirect exact to={routes.app.combinationTable.root} />;
  }

  return (
    <>
      <div className={styles.auth}>
        <Switch>
          <Route path={routes.auth.confirmEmail.root} component={ConfirmEmail} />
          <Route path={routes.auth.passwordChangeSuccess.root} component={PasswordChangeSuccess} />
          <Route path={routes.auth.recovery.root} component={RecoveryPassword} />
          <Route path={routes.auth.email.root} component={EmailNotification} />
          <Route path={routes.auth.recovery.root} component={RecoveryPassword} />
          <Route path={routes.auth.signUp.successful} component={Congratulations} />
          <Route path={routes.auth.signUp.root} component={SignUp} />
          <Route path={routes.auth.reset.root} component={ResetPassword} />
          <Route path={routes.auth.signIn.root} component={LogIn} />
          <Redirect to={routes.app.combinationTable.root} />
        </Switch>
      </div>
    </>
  );
};

const mapStateToProps = () => ({
});

export default connect<Props, Props, _, _, _, _>(mapStateToProps, null)(Auth);
